module.exports = __webpack_public_path__ + "static/media/table-chart.974cde19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/table-chart.svg
// module id = ./src/assets/icons/table-chart.svg
// module chunks = 0